import * as angular from "angular";

let NoResultsComponent = {
    selector: "vcNoResults",
    templateUrl: "/angular/components/help-text/no-results.component.html",
    bindings: {
        itemType: "=?",
        subheading: "=?",
        hint: "=?",
        actionHref: "=?",
        buttonText: "=?",
        headline: "=?",
        image: "=?",
        supportDocLink: "=?",
        supportDocUrl: "=?",
        action: "&",
    },
    controller: class NoResultsController {
        // * bindings for typescript compiler *
        public itemType?: any;
        public subheading?: string;
        public hint?: any;
        public actionHref?: any;
        public buttonText?: string;
        public headline?: string;
        public image?: any;
        public supportDocLink?: string;
        public supportDocUrl?: string;
        public action: any;
        // ************************************

        public imageUrl: string;
        public isLeaderView: boolean;

        constructor(__app_type: string) {
            this.isLeaderView = __app_type == "LEADER";
        }

        $onInit() {
            this.imageUrl = "/img/no-content/" + this.image;
        }

        clickAction(event: any): void {
            this.action(event);
        }
    },
};

angular
    .module("helpText")
    .component(NoResultsComponent.selector, NoResultsComponent);
